import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"


Vue.use(Vuex)

// const now = new Date();

const initialState = {
    user_id: "",
    user_name: "",
    user_class: "",
    mail_address: "",
    user_sub: "",
    user_token: "",
}

const store = new Vuex.Store({
    state: {
        routes: [],
        sessions: {},
        currentSession: null,
        //currentUser: JSON.parse(window.sessionStorage.getItem("user")),
        filterKey: '',
        stomp: null,
        isDot: {},
        initialState
    },
    mutations: {
        INIT_CURRENT_USER(state, user) {
            state.currentUser = user;
        },
        initRoutes(state, data) {
            state.routes = data;
        },
        changeCurrentSession(state, currentSession) {
            Vue.set(state.isDot, state.currentUser.username + '#' + currentSession.username, false);
            state.currentSession = currentSession;
        },

        setUserId(state, user_id) { state.user_id = user_id },
        setName(state, user_name) { state.user_name = user_name },
        setUserClass(state, user_class) { state.user_class = user_class },
        setMailAddress(state, mail_address) { state.mail_address = mail_address },
        setUserSub(state, user_sub) { state.user_sub = user_sub },
        setUserToken(state, user_token) { state.user_token = user_token },
        resetState(state) {
            state.user_id = "",
                state.user_name = "",
                state.user_class = "",
                state.mail_address = "",
                state.user_sub = "",
                state.user_token = "",
                state.routes.length = 0;
        }

    },
    actions: {

    },
    getters: {
        getUserId(state) { return state.user_id },
        getName(state) { return state.user_name },
        getUserClass(state) { return state.user_class },
        getMailAddress(state) { return state.mail_address },
        getUserSub(state) { return state.user_sub },
        getUserToken(state) { return state.user_token }
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage,
        key: 'ryokanri'
    })]
})

store.watch(function (state) {
    return state.sessions
}, function (val) {
    localStorage.setItem('vue-chat-session', JSON.stringify(val));
}, {
        deep: true
    })


export default store;